<template>
	<div class="page">
		<div class="menu">
			<el-menu :default-active="menuName" @select="selectMenu">
				<el-menu-item :index="item.name" v-for="(item,index) in menuList" :key="index"
					:class="menuName == item.name ? 'menu_on' : ''">
					<span slot="title">{{ item.name }}</span>
				</el-menu-item>
			</el-menu>
		</div>
		
		<div class="decor">
			<home class="phone-content">
				
			</home>
		</div>
	</div>
</template>

<script>
	import home from '../component/h5/home.vue';
	export default {
		components: {
			home
		},
		data() {
			return {
				menuName: 'H5首页',
				menuList: [{name: 'H5首页'}],
			};
		},
		methods: {
			selectMenu(e) {
				this.menuName = e;
			},
		}
	};
</script>

<style lang="scss" scoped>
	.page {
		background-color: #fff;
		width: 100%;
		// max-width: 1600px;
		margin: 0 auto;
		display: flex;
		max-height: 100vh;
		overflow: hidden;
		padding: 20px;
		box-sizing: border-box;
		
		.menu {
			width: 160px;
			min-width: 160px;
			margin-right: 30px;

			.menu_on {
				border-right: 2px solid #3E84E9;
			}
		}
		
		.decor {
			flex: 1;
			min-width: 0;
			display: flex;
			justify-content: center;
		}
	}
	
	@media (max-width: 1366px) {
		.page {
			padding: 15px;
			
			.menu {
				width: 140px;
				margin-right: 20px;
			}
		}
	}
</style>